import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import ErrorAlert from '../../Alerts/ErrorAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ModalParthners from '../../Modals/Parthners/ModalParthners';
import { UsersFetchAPI } from '../../../api/Users';
import Swal from 'sweetalert2';
import Keyboard from '../../utils/Keyboard';
import './ModalLoginUserByCode.css';


function ModalLoginUserByCode({ showLoginByCode, setShowLoginByCode, businessLogo, parthners, selectRestaurant, setResetData, calculateInvoiceTotals, shoppingCart, shoppingCartCombos, setShoppingCart, setShoppingCartCombos, setShowModalWarehouses, warehouses }) {

    const [passwordUser, setPasswordUser] = useState('');
    const [showVirtualKeyboard, setShowVirtualKeyboard] = useState(true);
    const [stepLogin, setStepLogin] = useState('code');
    const [keyboardMode, setKeyboardMode] = useState('letters_upper');
    const [authMode, setAuthMode] = useState('code_only');
    const [codeUser, setCodeUser] = useState('')
    const [showPassword, setShowPassword] = useState(true)
    let logoBusiness = ""

    if (localStorage.getItem('logo') != '' && localStorage.getItem('logo') != null && localStorage.getItem('logo') != undefined) {
        logoBusiness = localStorage.getItem('logo')
    } else {
        logoBusiness = businessLogo
    }
    const toogglePasword = () => {
        setShowPassword((prev) => !prev);
    }

    const validWarehouse = () => {
        if (localStorage.getItem('warehouse') == null || localStorage.getItem('warehouse') == undefined || localStorage.getItem('warehouse') == '' || localStorage.getItem('warehouse') == null) {
            if (warehouses.length > 0) { setShowModalWarehouses(true) }
        }
    }


    const getUserDataByCode = async () => {
        let token = localStorage.getItem('x-access-machine-token');
        const response = await UsersFetchAPI.getUserByCode(codeUser, token);
        return response.data.user;
    };



    const isCashierAdmin = (user) => {
        const roles = Array.isArray(user?.role) ? user.role : [];
        return roles.some((r) => {
            const roleName = (r?.name || '').toLowerCase().trim();
            return roleName === 'cajero admin'
        });
    };


    const handleCodeStepContinue = async () => {
        if (!codeUser.trim()) {
            ErrorAlert('', 'Debes ingresar el código de usuario', 'warning');
            return;
        }

        LoadingAlert();

        try {
            const user = await getUserDataByCode();

            const requirePassword =
                authMode === 'code_pass' &&
                isCashierAdmin(user);

            if (requirePassword) {
                setPasswordUser('');
                setKeyboardMode('letters_upper');
                setStepLogin('password');
                Swal.close();
                return;
            }

            Swal.close();
            await getUserByCode();
        } catch (err) {
            Swal.close();
            setCodeUser('');
            ErrorAlert('', 'Código inválido', 'error');
            console.log(err);
        }
    };


    //consulta el usuario por codigo
    const getUserByCode = async () => {
        LoadingAlert()
        let token = localStorage.getItem('x-access-machine-token')
        let branhoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let userDataNow = JSON.parse(localStorage.getItem('user'))
        try {
            const response = await UsersFetchAPI.getUserByCode(codeUser, token)
            let user = response.data.user
            console.log(response.data);

            let dataBranhAndUser = user.branchoffices.find(branch => branch.branchoffice_id == branhoffice.id)
            console.log(dataBranhAndUser);

            if (dataBranhAndUser == undefined) {

                getUserByIdCard(user)

            } else {
                userDataNow.id = user.id
                userDataNow.lastName = user.lastName
                userDataNow.name = user.name
                userDataNow.user_code = user.user_code
                userDataNow.email = user.email
                userDataNow.idCard = user.idCard
                userDataNow.business_id = user.business_id
                userDataNow.modules = user.modules
                userDataNow.permissions = user.permissions
                userDataNow.role = user.role
                localStorage.setItem('user', JSON.stringify(userDataNow))

                Swal.fire({
                    title: "Bienvenido " + user.name,
                    icon: "success",
                    draggable: true
                });
                validWarehouse()
                setShowLoginByCode(false)
            }

            setCodeUser('');
            setPasswordUser('');
            setStepLogin('code');
        } catch (err) {
            setCodeUser('');
            setPasswordUser('');
            ErrorAlert('', 'Codigo invalida', 'error')

            console.log(err);
        }

    }


    //consulta el usuario por codigo y password
    const getUserByCodeAndPassword = async () => {
        LoadingAlert()
        let token = localStorage.getItem('x-access-machine-token')
        let branhoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let userDataNow = JSON.parse(localStorage.getItem('user'))
        try {
            const response = await UsersFetchAPI.getUserByCodeAndPassword(codeUser, passwordUser, token)
            let user = response.data.user
            console.log(response.data);

            let dataBranhAndUser = user.branchoffices.find(branch => branch.branchoffice_id == branhoffice.id)
            console.log(dataBranhAndUser);

            if (dataBranhAndUser == undefined) {

                getUserByIdCard(user)

            } else {
                userDataNow.id = user.id
                userDataNow.lastName = user.lastName
                userDataNow.name = user.name
                userDataNow.user_code = user.user_code
                userDataNow.email = user.email
                userDataNow.idCard = user.idCard
                userDataNow.business_id = user.business_id
                userDataNow.modules = user.modules
                userDataNow.permissions = user.permissions
                userDataNow.role = user.role
                localStorage.setItem('user', JSON.stringify(userDataNow))

                Swal.fire({
                    title: "Bienvenido " + user.name,
                    icon: "success",
                    draggable: true
                });
                validWarehouse()
                setShowLoginByCode(false)
            }

            setCodeUser('');
            setPasswordUser('');
            setStepLogin('code');

        } catch (err) {
            setPasswordUser('');
            ErrorAlert('', ' Contraseña inválidos', 'error')
            console.log(err);
        }

    }


    //valida que el usuario con idCard este en la lista de usuarios de la sucursal o negocio
    const getUserByIdCard = async (userSelect) => {
        let token = localStorage.getItem('x-access-machine-token')
        let branhoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let userDataNow = JSON.parse(localStorage.getItem('user'))
        let business = JSON.parse(localStorage.getItem("business"))

        try {
            const response = await UsersFetchAPI.getUserByIdCard(userSelect.idCard, token)
            let arrayUser = response.data.user;
            let business_id = 0;

            if (branhoffice.parthner_business) {
                business_id = branhoffice.parthner_business
            } else {
                business_id = business.id
            }

            let userByBusiness = arrayUser.find(user => user.business_id === business_id)
            if (userByBusiness !== undefined) {
                userDataNow.id = userByBusiness.id
                userDataNow.lastName = userByBusiness.lastName
                userDataNow.name = userByBusiness.name
                userDataNow.user_code = userByBusiness.user_code
                userDataNow.email = userByBusiness.email
                userDataNow.idCard = userByBusiness.idCard
                userDataNow.business_id = userByBusiness.business_id
                localStorage.setItem('user', JSON.stringify(userDataNow))

                Swal.fire({
                    title: "Bienvenido " + userSelect.name,
                    icon: "success",
                    draggable: true
                });

                validWarehouse()
                setShowLoginByCode(false)
            } else {
                console.log("user not found")
                ErrorAlert("", userSelect.name + " " + "no tiene permitido facturar aqui.", "warning");
            }

        } catch (err) {
            console.log(err);
            ErrorAlert("", "Error de consulta de usuario", "error");
        }
    }


    useEffect(() => {
        const machine = JSON.parse(localStorage.getItem('machine')) || {};
        setAuthMode(machine.user_code_auth_mode || 'code_only');
    }, []);


    useEffect(() => {
        if (showLoginByCode) {
            setCodeUser('');
            setPasswordUser('');
            setStepLogin('code');
            setKeyboardMode('letters_upper');
        }
    }, [showLoginByCode]);

    const appendToCode = (value) => {
        setCodeUser((prev) => prev + value);
    };

    const removeLastCodeChar = () => {
        setCodeUser((prev) => prev.slice(0, -1));
    };

    const appendToPassword = (value) => {
        setPasswordUser((prev) => prev + value);
    };

    const removeLastPasswordChar = () => {
        setPasswordUser((prev) => prev.slice(0, -1));
    };

    const alphaKeyboardRows = [
        ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
        ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
        ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
    ];

    const numericKeyboardRows = [
        ['1', '2', '3'],
        ['4', '5', '6'],
        ['7', '8', '9'],
        ['0']
    ];

    const alphaLowerKeyboardRows = [
        ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
        ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
        ['z', 'x', 'c', 'v', 'b', 'n', 'm']
    ];

    const symbolKeyboardRows = [
        ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')'],
        ['-', '_', '=', '+', '[', ']', '{', '}', ';', ':'],
        ['.', ',', '/', '?', '|', '\\', "'", '"']
    ];

    return (
        <>
            <Modal
                show={showLoginByCode}
                size="lg"
                centered
                dialogClassName="sp-pin-dialog"
                contentClassName="sp-pin-content"
            >
                <Modal.Body className="sp-pin">


                    {/* Candado */}
                    <div className="sp-pin__brandmark">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 018 0v4" /></svg>
                    </div>

                    <h2 className="sp-pin__title">Smart Pay</h2>
                    <p className="sp-pin__subtitle">
                        {stepLogin === 'code' ? 'Ingresa tu PIN para continuar' : 'Ingresa tu contraseña'}
                    </p>

                    {stepLogin === 'code' && (
                        <>
                            {/* Puntos indicadores */}
                            <div className="sp-pin__dots">
                                {[0, 1, 2, 3].map((i) => (
                                    <span key={i} className={`sp-pin__dot ${codeUser.length > i ? 'is-on' : ''}`} />
                                ))}
                            </div>

                            {/* input real (oculto, conserva tu estado) */}
                            <input
                                type={showPassword ? 'password' : 'text'}
                                className="sp-pin__hidden"
                                id="code"
                                name="code"
                                required
                                spellCheck="false"
                                autoComplete="off"
                                inputMode="none"
                                readOnly
                                value={codeUser}
                                onChange={(e) => setCodeUser(e.target.value)}
                            />

                            {/* Teclado */}
                            <div className="sp-pin__pad">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                                    <button
                                        key={num}
                                        type="button"
                                        className="sp-pin__key"
                                        onClick={() => appendToCode(String(num))}
                                    >
                                        {num}
                                    </button>
                                ))}

                                <button
                                    type="button"
                                    className="sp-pin__key sp-pin__key--ghost"
                                    onClick={removeLastCodeChar}
                                >
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M21 4H8l-7 8 7 8h13a1 1 0 001-1V5a1 1 0 00-1-1z" /><line x1="18" y1="9" x2="12" y2="15" /><line x1="12" y1="9" x2="18" y2="15" /></svg>
                                </button>

                                <button
                                    type="button"
                                    className="sp-pin__key"
                                    onClick={() => appendToCode('0')}
                                >
                                    0
                                </button>

                                <button
                                    type="button"
                                    className="sp-pin__key sp-pin__key--ok"
                                    onClick={() => { handleCodeStepContinue() }}
                                >
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><polyline points="20 6 9 17 4 12" /></svg>
                                </button>
                            </div>
                        </>
                    )}

                    {stepLogin === 'password' && (
                        <>
                            <input
                                type={showPassword ? 'password' : 'text'}
                                className="sp-pin__input"
                                id="password_user"
                                name="password"
                                placeholder="*********"
                                readOnly={showVirtualKeyboard}
                                spellCheck="false"
                                autoComplete="off"
                                inputMode="none"
                                value={passwordUser}
                                onChange={(e) => setPasswordUser(e.target.value)}
                            />

                            <Keyboard txt={passwordUser} setTxt={setPasswordUser} showVirtualKeyboard={showVirtualKeyboard} setShowVirtualKeyboard={setShowVirtualKeyboard} />

                            <div className="sp-pin__pwactions">
                                <button
                                    type="button"
                                    className="sp-pin__btn sp-pin__btn--warning"
                                    onClick={() => {
                                        setPasswordUser('');
                                        setKeyboardMode('letters_upper');
                                        setStepLogin('code');
                                    }}
                                >
                                    Volver
                                </button>

                                <button
                                    type="button"
                                    className="sp-pin__btn sp-pin__btn--ok"
                                    onClick={() => {
                                        if (!passwordUser.trim()) {
                                            ErrorAlert('', 'Debes ingresar la contraseña', 'warning');
                                            return;
                                        }
                                        getUserByCodeAndPassword();
                                    }}
                                >
                                    <i className="uil uil-arrow-right"></i> Ingresar
                                </button>
                            </div>

                            <div className="sp-pin__check">
                                <input className="form-check-input" type="checkbox"
                                    value="remember-me" id="flexCheckDefault"
                                    onChange={toogglePasword}
                                />
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                    Mostrar contraseña
                                </label>
                            </div>
                        </>
                    )}

                    <small className="sp-pin__hint">
                        {authMode === 'code_pass'
                            ? 'Ingresa con tu código de usuario · si eres cajero admin, se pedirá contraseña'
                            : 'Ingresa con tu código de usuario'}
                    </small>


                    {/* Restaurante + socios (se mantiene tu ModalParthners) */}
                    {parthners.length > 0 ? <>
                        <div className="sp-pin__parthners"> 
                            <ModalParthners parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} calculateInvoiceTotals={calculateInvoiceTotals} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCart={setShoppingCart} setShoppingCartCombos={setShoppingCartCombos} />
                        </div></> : <></>}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalLoginUserByCode